exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-breadcrumb__separator {\r\n  color: #1E293B;\r\n  margin: 0 3px;\n} \r\n", ""]);

// exports
